export type PointerEvent = 'click' | 'change' | 'dblclick' | 'mouseup' | 'mousedown'

export function getElement< T extends Element >( selector: string, scope: ParentNode | Document ): T
export function getElement< T extends Element >( selector: string, scope: ParentNode | Document, isElementArray: true ): T[]
export function getElement< T extends Element >( selector: string, scope: ParentNode | Document, isElementArray: false ): T

export function getElement< T extends Element >( selector: string, scope: ParentNode | Document, isElementArray?: boolean ): T | T[] | null {
	try {
		const selectors = selector.split( ',' ).map( ( s ) => s.trim() )

		if ( isElementArray ) {
			const elements = selectors.flatMap( ( sel ) => [ ...scope.querySelectorAll( sel ) ] as T[] )
			return elements.length > 0 ? elements : []
		} else {
			for ( const sel of selectors ) {
				const element = scope.querySelector( sel ) as T
				if ( element ) {
					return element
				}
			}
			return null
		}
	} catch ( e ) {
		throw new Error( `There is an error. Please check if your selector: ${ selector } is correct.` )
	}
}

export async function domEvent< T extends Element >( el: string, event: PointerEvent, func: ( value: Event ) => void ) {
	const element = getElement< T >( el, document, false )
	if ( ! element ) return

	return element?.addEventListener( event, ( value ) => func( value ) )
}
